<template>
  <div class="ui top fixed borderless menu">
    <div class="ui container">
      <sui-dropdown class="icon" icon="bars" item floating direction="downward">
        <sui-dropdown-menu>
          <sui-dropdown-item @click="goHome"
            ><sui-icon name="home" />Inicio</sui-dropdown-item
          >
          <sui-dropdown-item v-if="isAuthenticated" @click="goOrders"
            ><sui-icon name="dolly" />Mis Pedidos
          </sui-dropdown-item>
          <sui-dropdown-item v-if="isAuthenticated" @click="goProfile"
            ><sui-icon name="user" />Mi Cuenta
          </sui-dropdown-item>

          <sui-dropdown-item v-if="isAuthenticated" @click="logout">
            <sui-icon name="logout" />Cerrar Sesión
          </sui-dropdown-item>

          <sui-dropdown-item v-if="!isAuthenticated" @click="login">
            <sui-icon name="key" />Iniciar sesión
          </sui-dropdown-item>
          <sui-dropdown-item v-if="!isAuthenticated" @click="signup">
            <sui-icon name="user" />Regístrate
          </sui-dropdown-item>
        </sui-dropdown-menu>
      </sui-dropdown>
      <router-link to="/" class="header item">
        <img class="logo" :src="logo" />InStock
      </router-link>
      <a
        href="javascript:void(0)"
        v-for="category in categories"
        :key="category._id"
        class="item"
        @click="
          goToCategory(category._id);
          return false;
        "
      >
        {{ category.name }}
      </a>
      <div class="right menu">
        <a class="ui item" href="#/cart">
          <i class="cart icon"></i>
          <div class="ui teal label">{{ totalItems }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: ['isHome', 'items'],
  computed: {
    totalItems: function() {
      return this.$store.getters['cart/totalItems'];
    },
    isAuthenticated: function() {
      return this.$store.getters['auth/isAuthenticated'];
    },
    categories: function() {
      return this.$store.getters['categories/getMenuCats'];
    },
    logo: function() {
      return this.$store.getters['application/getLogo'];
    }
  },
  methods: {
    login: function() {
      this.$router.push('login');
    },
    logout: function() {
      this.$store.dispatch('auth/logout');
      this.goHome();
    },
    signup: function() {
      this.$router.push('signup');
    },
    goHome: function() {
      this.$router.push('/');
    },
    goProfile: function() {
      this.$router.push('/customer/profile');
    },
    goOrders: function() {
      this.$router.push('/orders');
    },
    goToCategory: async function(categoryId) {
      const payload = {
        categories: [categoryId],
        brands: []
      };

      //this.$store.dispatch('categories/loadCategory', payload);
      await this.$store.dispatch('products/loadProductsByCategory', {
        categoryId: categoryId,
        page: 1
      });
    }
  }
};
</script>

<style lang="css">
.horizontal {
  display: flex;
  flex-direction: row;
}
</style>
